import React, { useState, useEffect, useContext } from 'react';
import { Box, Button, Typography,  } from 
'@mui/material';
import { SymptomDetailsContext } from '../../../../utilities/context.js'
import storyCore from '../../../../utilities/Story/storyCore.js';
import StoryEditorModal from "../symptom story/storyEditorModal";

function Story(props) { 
const {extraSymptomDetails, story, setStory} = useContext(SymptomDetailsContext) 
const [text, setText] = useState()
const [oldText, setOldText] = useState()


const [modalOpen, setModalOpen]= useState(false) //controls editor box modal
const FinishedAdding=()=>
    {
    if (story === undefined || story === text )
        { 
        setOldText(text)
        setStory(text)
        setModalOpen(true);// opens editor box modal
        }

    else if (text === oldText)
        {
        setModalOpen(true)
        }
        
    else
        {
        //tries to correct for addition of extas symptoms after story has been edited by extracting new information and adding to existing story- fails with compound sentences.
        let newText = `${text}`
        let previousText = `${oldText}`
        let additions=newText.replace(previousText,"")
        let newStory =story + additions
        setStory(newStory)
        setModalOpen(true)
        }
    }
 
useEffect(()=>{setText(storyCore.writeSymptomText(extraSymptomDetails, props.melanomaSevenPoint, props.idaValues))
})

return ( 
<Box>
<Typography varient="subtext3">{text}</Typography>
<Button size="small" variant='contained' onClick={FinishedAdding}> Finished Adding Symptom Info </Button>
<StoryEditorModal  modalOpen={modalOpen} setModalOpen={setModalOpen}/>
</Box>)
}

export default Story